// Vue plugin <filtrera-datatable>:

'use strict';

const plugin = {

	install(Vue, options) {

		Vue.component('filtrera-datatable', {

			// Ikonen nedan är renderad i viewn och sedan inkopierad här. Se utkommenterad kod i Kontoplan.cshtml. Obs! För att måttangivelserna skulle stämma lade jag manuellt in div-containern i den renderade viewn medelst Chrome webtools: 
			template: '\
				<div :disabled="vpInaktiverad || tabellobjekt === null">\
					<input v-model.trim="filtertext" class="_sidinnehall_filter" :class="{ \'-ifylld\': arIfylld }" type="text" :placeholder="placeholderText" title="Fyll i ett eller flera ord eller<br>värden så filtreras listan efter dessa">\
					<svg version="1.1" x="0px" y="0px" xml:space="preserve" viewBox="0 0 200 180"\
						style="overflow: visible; stroke-linecap:round; stroke-linejoin:round; stroke-miterlimit:10;\
						fill:none; stroke:rgb(152, 151, 148); stroke-width:13;\
						height:1em; width:1em; top:0.5em; left:.3em; position:absolute; pointer-events:none;">\
						<g id="Filter-01"><path d="M20.13,19.75l60,85v55l40-15v-40l60-85H20.13z"></path></g>\
					</svg>\
				</div>\
			',

			/* Ang props-validering, se https://vuejs.org/v2/guide/components.html#Prop-Validation */
			props: {
				vpInaktiverad: {
					type: Boolean,
					default: false,
				},
				placeholderText: {
					type: String,
					default: 'Filtrera listan...',
				},
				tabellobjekt: {
					type: Object,
					default: null,	// null = inte satt än.
				},
			},
			data() {
				return {
					filtertext: '',
				};
			},
			computed: {
				arIfylld() {
					return this.filtertext !== '';
				},
			},
			watch: {
				filtertext(nyttVarde, tidigareVarde) {
					// Hit kan man egentligen aldrig komma när tabellobjekt = null, då komponenten då är inaktiverad, men för sakens skull:
					if (this.tabellobjekt === null)
						return;

					this.tabellobjekt.search(nyttVarde).draw();
				},
			},
		});


		// Exempel för en Vue plugin:

		//// 1. add global method or property
		//Vue.myGlobalMethod = function () {
		//	// something logic ...
		//}

		//// 2. add a global asset
		//Vue.directive('my-directive', {
		//	bind(el, binding, vnode, oldVnode) {
		//		// something logic ...
		//	}
		//	// ...
		//})

		//// 3. inject some component options
		//Vue.mixin({
		//	created() {
		//		// something logic ...
		//	}
		//	//...
		//  })

		//// 4. add an instance method
		//Vue.prototype.$myMethod = function (methodOptions) {
		//	// something logic ...
		//}
	}

};

export { plugin as ssoFiltreraDatatable };
